import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import React, { useState } from 'react'

const FormModalCreateAgencia = ({ onSave, initialData }) => {
    const [descripcion, setDescripcion] = useState(initialData?.descripcion || '');

    const submit = e => {
        e.preventDefault()
        if (!descripcion.trim()) {
            Swal.fire('Error', 'Debe completar la Descripción', 'error')
            return
        }
        console.log('Agencia creada:', { descripcion })
        onSave({ descripcion })
    }
    
    return (
        <>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Nombre</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nombre de la agencia"
                        value={descripcion}
                        maxLength={50} // aquí siempre va un número
                        onChange={e => { setDescripcion(e.target.value) }}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <div className="d-flex justify-content-end">
                <button className='btn-primary-modals-maestros' onClick={submit}>
                    Guardar
                </button>
            </div>
        </>
    )
}

export default FormModalCreateAgencia
